function validDay(day) {
  if (typeof day !== "number") return false;
  if (day < 0) return false;
  if (day > 6) return false;
  return true;
}

function validTime(time) {
  return time && !isNaN(Number(time.hour));
}

function validateDays(days) {
  return [].concat(days).filter(validDay);
}

function validateTimes(times) {
  return [].concat(times).filter(validTime);
}

export default function selectedText(times, days) {
  const validTimes = validateTimes(times);
  const validDays = validateDays(days);
  if (!validTimes.length || !validDays.length)
    return "You won't receive your list, please add both a time and day.";
  return "I send your list on these days:";
}



// WEBPACK FOOTER //
// ./src/components/DaysSelect/selectedText.js